import * as React from 'react';
import { Component } from 'react';
import { RouteComponentProps } from 'react-router';
import { IdentityService } from '../../services/IdentityService';
import { ShowStatusBar } from '../Layout/GlobalStatusBar';
// import { CheckBoxComponent } from '../../controls/CheckBox';
import { connect } from 'react-redux';
import { IUserInfo } from '../../models/IUserInfo';
import { IChangePasswordModel } from '../../models/IChangePasswordModel';
import { DEFAULT_STATUS_TIMEOUT } from '../../constants/SystemConsts';
import { IPinModel } from '../../models/IPinModel';
import NavMenu from '../NavMenu/NavMenu';
import Footer from '../../components/Login/Footer';
import { BigFooter } from '../../components/Login/BigFooter';
import { FormGroup } from '../../controls/Form/FormGroup';
import { ExpansionPanel } from '../../controls/ExpansionPanel';
import { PinForm } from '../../controls/Form/PinForm';
import { PasswordHelpBlock } from './PasswordHelpBlock';
import {
    GetPasswordValidationState,
    GetConfirmPassowrdValidationState,
    fullPasswordChangeValidation
} from './PasswordValidation';

import "./LogIn.css";
import Modal from "../Modal/Modal";

interface IHistory {
    date: string,
    device: string,
    place: string,
    status: string
}

function MapState(state) {
    return {
        UserInfo: state.Profile
    }
}

interface IState {
    UserId?: string;
    ResetCode?: string;
    IsFormPristine?: boolean;
    LoaderVisible?: boolean;
    OldPassword: string;
    Password: string;
    ConfirmPassword: string;
    ResetSuccess?: boolean;
    Pin: string;
    PinConfirm: string;
    Finezjo: boolean;
    ZF: boolean;
    PF: boolean;
    History: IHistory[];
    HistoryQuantity: number;
    DidSubmit: boolean;
    HideShowMoreHistory: boolean;
    PinExpanded: boolean;
    PasswordExpanded: boolean;
    IsDeletePinModalVisible: boolean;
}

interface IProps extends RouteComponentProps<any> {
    UserInfo: IUserInfo | null;
}

class SettingsComponent extends Component<IProps, IState> {
    private pinDidSubmit = false;

    constructor(props) {
        super(props);

        this.state = {
            IsFormPristine: true,
            LoaderVisible: false,
            ResetSuccess: false,
            ConfirmPassword: '',
            Password: '',
            OldPassword: '',
            Pin: '',
            PinConfirm: '',
            Finezjo: true,
            PF: false,
            ZF: false,
            HistoryQuantity: 20,
            History: [],
            DidSubmit: false,
            HideShowMoreHistory: false,
            PinExpanded: false,
            PasswordExpanded: false,
            IsDeletePinModalVisible: false
        }

        this.GetData();
        const { UserInfo, history } = this.props;
        if (UserInfo !== null) {
            if (UserInfo.isAuthenticated === false) {
                history.replace('/');
            }
        }
    }

    public componentWillReceiveProps(nextProps: IProps) {
        if (nextProps.UserInfo !== null) {
            if (!nextProps.UserInfo.isAuthenticated) {
                this.props.history.replace('/');
            }
        }
    }

    public render() {
        if (this.props.UserInfo === null) {
            return (<div />)
        }
        const { Password, OldPassword, ConfirmPassword, Pin, PinConfirm, History, HideShowMoreHistory, PinExpanded, PasswordExpanded } = this.state;
        return (
            <div className="login-component route-component form-component">
                <NavMenu history={this.props.history} />
                {this.RenderDeletePinModal()}
                <div className="settings">
                    <div className="app-chooser-content">
                        <div className="header">
                            <h3>Ustawienia i bezpieczeństwo</h3>
                        </div>
                        <div className="settings-container">
                            <div className="panel-header">
                                <div className="lock-icon" />
                                <p className="panel-header__title">Logowanie</p>
                            </div>
                            <ExpansionPanel
                                OnClick={this.ExpandPassword}
                                Expanded={PasswordExpanded}
                                Header={
                                    <div className="expansion-header">
                                        <p className="expansion-header__title">Hasło</p>
                                        <div className="button button--empty expansion-header__button">
                                            <p>Zmień hasło</p>
                                        </div>
                                        <div className="button button--empty expansion-header__button expansion-header__button--mobile">
                                            <p>Edytuj</p>
                                        </div>
                                    </div>
                                }
                                ExpandedHeader={
                                    <div className="expansion-header">
                                        <p className="expansion-header__title">Hasło</p>
                                        <div className="expanded-buttons">
                                            <div
                                                onClick={this.CancelPasswordChange}
                                                className="button button--empty">
                                                <p>Anuluj</p>
                                            </div>
                                            <div
                                                onClick={this.ChangePasswordSave}
                                                className="button button--filled">
                                                <p>Zapisz</p>
                                            </div>
                                        </div>
                                    </div>
                                }
                                ExpansionPanelClass="password-change-helper"
                                PanelClass="password-change-container"
                            >
                                <div className="password-change-inputs">
                                    <FormGroup
                                        Name="OldPassword"
                                        OnChange={this.OnInputChange}
                                        LabelSide={true}
                                        CustomLabel={
                                            <p className="password-change-label">Stare hasło</p>
                                        }
                                        Value={OldPassword}
                                        Type="password"
                                        ClassName="form-group--no-margin"
                                    />
                                    <FormGroup
                                        Name="Password"
                                        OnChange={this.OnInputChange}
                                        LabelSide={true}
                                        CustomLabel={
                                            <p className="password-change-label">Nowe hasło</p>
                                        }
                                        Value={Password}
                                        Type="password"
                                        ClassName="form-group--no-margin"
                                        ValidationState={this.GetPasswordValidationStateHandler}
                                        ErrorBlock="Hasło musi zawierać conajmniej 8 znaków"
                                    />
                                    <FormGroup
                                        Name="ConfirmPassword"
                                        OnChange={this.OnInputChange}
                                        LabelSide={true}
                                        CustomLabel={
                                            <p className="password-change-label">Powtórz hasło</p>
                                        }
                                        Value={ConfirmPassword}
                                        ValidationState={this.GetConfirmPasswordValidationStateHandler}
                                        ErrorBlock="Hasła muszą być takie same"
                                        Type="password"
                                        ClassName="form-group--no-margin"
                                    />
                                </div>
                                <div className="password-change-help-block">
                                    <PasswordHelpBlock
                                        Password={Password}
                                        ClassNames="password-change-block" />
                                </div>
                            </ExpansionPanel>
                            <ExpansionPanel
                                OnClick={this.ExpandPin}
                                Expanded={PinExpanded}
                                Header={
                                    <div className="expansion-header expansion-header--rounded">
                                        <div className="expansion-header__wrapper">
                                            <p className="expansion-header__title">
                                                PIN:
                                                {Pin ? <span className="expansion-header__pin-status expansion-header__pin-status--enabled">Włączony</span> : <span className="expansion-header__pin-status">Wyłączony</span>}
                                            </p>
                                            <p className="expansion-header__sub-title">Gdy sesja wygaśnie, możemy poprosić o wpisanie PIN zamiast hasła.</p>
                                        </div>
                                        {Pin ?
                                            <div className="expansion-header__buttons-wrapper">
                                                <div onClick={this.OnDeletePinModalToggle} className="button button--empty expansion-header__button-small">
                                                    <p>Usuń PIN</p>
                                                </div>
                                                <div onClick={this.OnDeletePinModalToggle} className="button button--empty expansion-header__mobile-delete-button" />
                                                <div className="button button--empty expansion-header__button-small">
                                                    <p>Zmień PIN</p>
                                                </div>
                                                <div className="button button--empty expansion-header__button-small expansion-header__button-small--mobile">
                                                    <p>Edytuj</p>
                                                </div>
                                            </div>
                                            :
                                            <div className="expansion-header__buttons-wrapper">
                                                <div className="button button--empty expansion-header__button">
                                                    <p>Dodaj PIN</p>
                                                </div>
                                                <div className="button button--empty expansion-header__button-small expansion-header__button-small--mobile">
                                                    <p>Dodaj</p>
                                                </div>
                                            </div>
                                        }

                                    </div>
                                }
                                ExpandedHeader={
                                    <div className="expansion-header">
                                        <div className="expansion-header__wrapper">
                                            <p className="expansion-header__title">
                                                PIN:
                                                {Pin ? <span className="expansion-header__pin-status expansion-header__pin-status--enabled">Włączony</span> : <span className="expansion-header__pin-status">Wyłączony</span>}
                                            </p>
                                            <p className="expansion-header__sub-title">Gdy sesja wygaśnie, możemy poprosić o wpisanie PIN zamiast hasła.</p>
                                        </div>
                                        <div className="expanded-buttons">
                                            <div className="button button--empty">
                                                <p>Anuluj</p>
                                            </div>
                                            <div
                                                onClick={this.OnPinChangeSave}
                                                className="button button--filled">
                                                <p>Zapisz</p>
                                            </div>
                                        </div>
                                    </div>
                                }
                                ExpansionPanelClass="pin-change-helper"
                                PanelClass="pin-change-container"
                            >
                                <div className="pin-change-wrapper">
                                    <div className="pin-inputs-wrapper">
                                        <PinForm
                                            Label="Twój kod pin"
                                            Value={Pin}
                                            OnPinChange={this.OnPinChange}
                                            ValidationState={this.GetPinValidationState}
                                            ErrorBlock="Pin musi mieć 4 cyfry!"
                                        />
                                        <PinForm
                                            Label="Powtórz kod pin"
                                            Value={PinConfirm}
                                            OnPinChange={this.OnPinConfirmChange}
                                            ValidationState={this.GetPinConfirmValidationState}
                                            ErrorBlock="Pin musi być taki sam!"
                                        />
                                    </div>
                                    {/* <div className="pin-checkbox">
                                        <ExpansionPanel
                                            Header={
                                                <div className="pin-checkbox__header">
                                                    <div className="pin-checkbox__header-wrapper">
                                                        <p className="pin-checkbox__title">Używaj PIN w serwisach</p>
                                                        <p className="pin-checkbox__sub-title">
                                                            {
                                                                !ZF && !PF && "Finezjo (domyślnie)"
                                                            }
                                                            {
                                                                Finezjo && (ZF || PF) && "Finezjo"
                                                            }
                                                            <br />
                                                            {
                                                                ZF && "Znajdź Fizjoterapeutę"
                                                            }
                                                            <br />
                                                            {
                                                                PF && "Portal Fizjoterapeuty"
                                                            }
                                                        </p>
                                                    </div>

                                                    <div className="button button--empty">
                                                        <p>Edytuj</p>
                                                    </div>
                                                </div>
                                            }
                                            ExpandedHeader={
                                                <div className="pin-checkbox__header pin-checkbox__header--flat">
                                                    <div className="pin-checkbox__header-wrapper">
                                                        <p className="pin-checkbox__title">Używaj PIN w serwisach</p>
                                                    </div>
                                                </div>
                                            }
                                            ExpansionPanelClass="pin-checkbox-wrapper"
                                            Expanded={window.innerWidth < 450}
                                        >
                                            <div className="pin-checkbox-container">
                                                <CheckBoxComponent
                                                    Checked={Finezjo}
                                                    Label={
                                                        <span className="agreements">
                                                            Finezjo
                                                        </span>
                                                    }
                                                    OnClick={this.OnCheckboxToggle.bind(this, "Finezjo")}
                                                    ClassNames="checkbox"
                                                    LabelClassNames="checkbox__label"
                                                />
                                                <CheckBoxComponent
                                                    Checked={ZF}
                                                    Label={
                                                        <span className="agreements">
                                                            Znajdź Fizjoterapeutę
                                                        </span>
                                                    }
                                                    OnClick={this.OnCheckboxToggle.bind(this, "ZF")}
                                                    ClassNames="checkbox"
                                                    LabelClassNames="checkbox__label"
                                                />
                                                <CheckBoxComponent
                                                    Checked={PF}
                                                    Label={
                                                        <span className="agreements">
                                                            Portal Fizjoterapeuty
                                                        </span>
                                                    }
                                                    OnClick={this.OnCheckboxToggle.bind(this, "PF")}
                                                    ClassNames="checkbox"
                                                    LabelClassNames="checkbox__label"
                                                />
                                            </div>
                                        </ExpansionPanel>
                                    </div> */}
                                </div>
                            </ExpansionPanel>
                            <div className="panel-header panel-header--margin-top">
                                <div className="align-left-icon" />
                                <p className="panel-header__title">Historia logowania</p>
                            </div>
                            {
                                History.map((item, index) => {
                                    return (
                                        <div
                                            key={index}
                                            className="history-panel">
                                            <p>{item.device}</p>
                                            <p className={index === 0 ? "active-session" : ""}>{index === 0 ? "Aktywna sesja" : `Ostatnie logowanie: ${item.date}`}</p>
                                        </div>
                                    )
                                })
                            }
                            <div
                                onClick={!HideShowMoreHistory ? this.OnGetMoreHistory : () => { }}
                                className={`panel-footer ${HideShowMoreHistory ? "panel-footer--disabled" : ""}`}>
                                <p className="panel-footer__title">Pokaż więcej</p>
                            </div>
                        </div>
                    </div>
                </div>
                <BigFooter />
                <Footer />
            </div>
        );
    }

    private ExpandPin = () => {
        this.setState({
            PinExpanded: !this.state.PinExpanded
        })
    }

    private ExpandPassword = () => {
        this.setState({
            PasswordExpanded: !this.state.PasswordExpanded
        })
    }

    private GetData = () => {
        let identity = new IdentityService();
        identity.GetSettingsInfo(this.OnGetDataSuccess, this.OnGetDataError)
    }

    private OnGetDataSuccess = (res) => {
        const data = res.data;
        const pinData = data.pin;
        this.setState({
            History: data.history,
            Pin: pinData.pin,
            PinConfirm: pinData.confirmPin,
            Finezjo: pinData.forFinezjo,
            ZF: pinData.forZF,
            PF: pinData.forPortal
        })
    }

    private OnGetDataError = (err) => {
        ShowStatusBar("Error", "Nie udało się pobrać historii logowania", DEFAULT_STATUS_TIMEOUT);
    }

    private OnDeletePinModalToggle = (e) => {
        e.stopPropagation();
        this.setState({
            IsDeletePinModalVisible: !this.state.IsDeletePinModalVisible
        });
    }

    private RenderDeletePinModal = () => {
        if (this.state.IsDeletePinModalVisible) {
            return (
                <Modal
                    onCloseClick={this.OnDeletePinModalToggle}
                >
                    <div className="delete-pin-modal">
                        <div
                            onClick={this.OnDeletePinModalToggle}
                            className="delete-pin-modal__close-button" />
                        <h2 className="delete-pin-modal__title">
                            Usuń PIN
                        </h2>
                        <p className="delete-pin-modal__text">
                            Czy na pewno chcesz usunąć PIN?
                            <br />
                            Od teraz będziesz odblokowywać ekran swoim hasłem.
                        </p>
                        <div className="delete-pin-modal__buttons">
                            <div onClick={this.OnDeletePinModalToggle} className="button button--empty button--big delete-pin-modal__button">
                                <p>Anuluj</p>
                            </div>
                            <div onClick={this.OnDeletePin} className="button button--big button--filled delete-pin-modal__button">
                                <p>Usuń PIN</p>
                            </div>
                        </div>
                    </div>
                </Modal>
            )
        } else {
            return null;
        }
    }

    private OnDeletePin = () => {
        const identity = new IdentityService();
        identity.RemovePin(
            () => {
                this.setState({
                    IsDeletePinModalVisible: false
                });
                ShowStatusBar("Success", "Pin usunięty");
                this.GetData();
            },
            () => {
                ShowStatusBar("Error", "Nie udało się usunąć PINu");
            }
        );
    }

    // private OnCheckboxToggle = (item, event) => {
    //     let partialState = {};
    //     partialState[item] = !this.state[item];
    //     this.setState({
    //         ...partialState
    //     })
    // }

    private CancelPasswordChange = () => {
        this.setState({
            OldPassword: "",
            Password: "",
            ConfirmPassword: "",
            DidSubmit: false
        })
    }

    private ChangePasswordSave = (e) => {
        const { Password, ConfirmPassword, OldPassword } = this.state;
        e.stopPropagation();
        this.setState({
            DidSubmit: true
        }, () => {
            if (fullPasswordChangeValidation(Password, ConfirmPassword, true)) {
                let identity = new IdentityService();
                let model: IChangePasswordModel = {
                    OldPassword,
                    Password,
                    ConfirmPassword
                };
                identity.ChangePassword(model, this.OnChangePasswordSuccess, this.OnChangePasswordError);
            } else {
                ShowStatusBar("Info", "Sprawdź poprawnośc formularza", DEFAULT_STATUS_TIMEOUT);
            }
        });
    }

    private OnChangePasswordSuccess = (res) => {
        this.setState({
            PasswordExpanded: false
        });
        ShowStatusBar("Success", "Hasło zmienione", DEFAULT_STATUS_TIMEOUT);
    }

    private OnChangePasswordError = (err) => {
        ShowStatusBar("Error", "Nie udało się zmienić hasła", DEFAULT_STATUS_TIMEOUT);
    }

    private GetPinValidationState = (): 'success' | 'warning' | 'error' | undefined => {
        const { Pin } = this.state;
        if (this.pinDidSubmit === false) {
            return undefined;
        }

        if (Pin) {
            if (Pin.replace(" ", "").length === 4) {
                return "success";
            }
            return "error";
        }
        return "error";
    }

    private GetPinConfirmValidationState = (): 'success' | 'warning' | 'error' | undefined => {
        const { Pin, PinConfirm } = this.state;
        if (this.pinDidSubmit === false) {
            return undefined;
        }
        if (Pin) {
            if (Pin === PinConfirm) {
                return "success";
            }
            return "error"
        }
        return "error"
    }

    private GetPasswordValidationStateHandler = (): 'success' | 'warning' | 'error' | undefined => {
        const { Password, DidSubmit } = this.state;
        return GetPasswordValidationState(DidSubmit, Password);
    }

    private GetConfirmPasswordValidationStateHandler = (): 'success' | 'warning' | 'error' | undefined => {
        const { Password, ConfirmPassword, DidSubmit } = this.state;
        return GetConfirmPassowrdValidationState(DidSubmit, Password, ConfirmPassword);
    }

    private OnInputChange = (event) => {
        let partialState = {};
        partialState[event.target.name] = event.target.value;
        this.setState({
            ...partialState,
            IsFormPristine: false
        });
    }

    private OnPinChange = (pin) => {
        this.setState({
            Pin: pin
        })
    }

    private OnPinConfirmChange = (pin) => {
        this.setState({
            PinConfirm: pin
        })
    }

    private OnPinChangeSave = (e) => {
        e.stopPropagation();
        const { Pin, PinConfirm, Finezjo, PF, ZF } = this.state;
        this.pinDidSubmit = true;
        if (this.GetPinValidationState() === 'success' && this.GetPinConfirmValidationState() === "success") {
            let identity = new IdentityService();
            let model: IPinModel = {
                pin: Pin,
                confirmpin: PinConfirm,
                forFinezjo: Finezjo,
                forPortal: PF,
                forZF: ZF
            };
            identity.SetPin(model, this.OnChangePinSuccess, this.OnChangePinError);
        } else {
            ShowStatusBar("Info", "Sprawdź poprawność formularza", DEFAULT_STATUS_TIMEOUT);
        }
        this.setState({});
    }

    private OnChangePinSuccess = (res) => {
        this.setState({
            PinExpanded: false
        });
        ShowStatusBar("Success", "PIN nadany", DEFAULT_STATUS_TIMEOUT);
    }

    private OnChangePinError = (err) => {
        ShowStatusBar("Error", "Nie udało się nadać kodu PIN", DEFAULT_STATUS_TIMEOUT);
    }

    private OnGetMoreHistory = () => {
        let identity = new IdentityService();
        identity.GetLoginHistory(this.state.HistoryQuantity + 20, this.OnGetMoreHistorySuccess, this.OnGetMoreHistoryError);
    }

    private OnGetMoreHistorySuccess = (res) => {
        const { History, HistoryQuantity } = this.state;
        this.setState({
            History: res.data,
            HistoryQuantity: HistoryQuantity + 20,
            HideShowMoreHistory: res.data.length === History.length
        });
    }

    private OnGetMoreHistoryError = () => {
        ShowStatusBar("Error", "Nie udało się pobrać dodatkowej historii logowania", DEFAULT_STATUS_TIMEOUT);
    }
}

export default connect(MapState)(SettingsComponent);


// WEBPACK FOOTER //
// ./src/components/Login/Settings.tsx